import { postRoute } from "../client"

export const markStreakSeenRoute = postRoute<{ success: true }>("/api/engagement/streak/seen")
